import { Link } from 'react-router-dom'

export default function Terms() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-primary-600 text-white py-16">
        <div className="container mx-auto px-6">
          <Link to="/" className="text-white hover:text-primary-100 mb-4 inline-block">
            ← Back to Home
          </Link>
          <h1 className="text-4xl font-bold mt-4">Terms of Service</h1>
          <p className="text-primary-100 mt-2">Last updated: March 2024</p>
        </div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-6 py-16">
        <div className="max-w-3xl mx-auto bg-white rounded-2xl p-8 shadow-sm">
          <div className="prose prose-lg">
            <h2>1. Agreement to Terms</h2>
            <p className="text-gray-600 mb-6">
              By accessing or using EmailBrain's services, you agree to be bound by these Terms of Service 
              and all applicable laws and regulations. If you do not agree with any part of these terms, 
              you may not use our services.
            </p>

            <h2>2. Description of Service</h2>
            <p className="text-gray-600 mb-6">
              EmailBrain provides an AI-powered email marketing platform that helps businesses create, 
              manage, and analyze email campaigns. We reserve the right to modify, suspend, or discontinue 
              any part of our service at any time.
            </p>

            <h2>3. User Accounts</h2>
            <p className="text-gray-600 mb-6">
              To use our service, you must create an account. You are responsible for:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-600">
              <li>Maintaining the security of your account</li>
              <li>All activities that occur under your account</li>
              <li>Providing accurate and complete information</li>
              <li>Not sharing your account credentials</li>
            </ul>

            <h2>4. Acceptable Use</h2>
            <p className="text-gray-600 mb-6">
              You agree not to use EmailBrain to:
            </p>
            <ul className="list-disc pl-6 mb-6 text-gray-600">
              <li>Send spam or unsolicited emails</li>
              <li>Violate any laws or regulations</li>
              <li>Infringe on intellectual property rights</li>
              <li>Distribute malware or harmful content</li>
              <li>Harass or abuse other users</li>
            </ul>

            <h2>5. Billing and Payments</h2>
            <p className="text-gray-600 mb-6">
              Subscription fees are billed in advance on a monthly or annual basis. We accept major credit 
              cards and PayPal. Refunds are handled according to our refund policy. You may cancel your 
              subscription at any time.
            </p>

            <h2>6. Cancellation and Termination</h2>
            <p className="text-gray-600 mb-6">
              You may cancel your account at any time. We may terminate or suspend your account immediately, 
              without prior notice, for conduct that we believe violates these Terms or is harmful to other 
              users, us, or third parties.
            </p>

            <h2>7. Intellectual Property</h2>
            <p className="text-gray-600 mb-6">
              The EmailBrain service, including its original content, features, and functionality, is owned 
              by EmailBrain and is protected by international copyright, trademark, and other intellectual 
              property laws.
            </p>

            <h2>8. Limitation of Liability</h2>
            <p className="text-gray-600 mb-6">
              EmailBrain shall not be liable for any indirect, incidental, special, consequential, or punitive 
              damages, including without limitation, loss of profits, data, use, goodwill, or other intangible 
              losses, resulting from your use or inability to use the service.
            </p>

            <h2>9. Changes to Terms</h2>
            <p className="text-gray-600 mb-6">
              We reserve the right to modify these terms at any time. We will notify users of any material 
              changes via email or through our service. Your continued use of EmailBrain after such changes 
              constitutes your acceptance of the new terms.
            </p>

            <h2>10. Contact Information</h2>
            <p className="text-gray-600 mb-6">
              If you have any questions about these Terms, please contact us at:
            </p>
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-gray-600">Email: legal@emailaipro.com</p>
              <p className="text-gray-600">Address: 123 Innovation Drive, San Francisco, CA 94105</p>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-white border-t border-gray-200 py-8">
        <div className="container mx-auto px-6 text-center text-gray-500">
          <p>&copy; 2024 EmailBrain. All rights reserved.</p>
        </div>
      </footer>
    </div>
  )
}